import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { observer } from "mobx-react";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import OrderTabs from "./components/orderTabs";
import { useStores } from "@/app/csr-src/models";
import styles from "./orderList.module.scss";
import { WareInfoListVo } from "@/app/csr-src/apis/order/order.interface";
import { Helmet } from "react-helmet";
// 埋点
import { sendPv } from "@/tracks/25335";
interface ProfileListContext {
  updateNumber: () => void;
  initRecommendMainSkus: (mainSkus: string) => void;
}

const OrderList = observer(() => {
  const { t } = useTranslation();
  const { orderStore } = useStores();
  console.log(orderStore, sessionStorage, "sjk-orderList-info");

  // 埋点需要的数据
  const orderTabList = [
    {
      name: t("order.orderList.orderTabs.allTab"),
      state: "4096",
    },
    {
      name: t("order.orderList.orderTabs.unpaidTab"),
      state: "1",
    },
    {
      name: t("order.orderList.orderTabs.pendingReceiptTab"),
      state: "128",
    },
    {
      name: t("order.orderList.orderTabs.completedTab"),
      state: "1024",
    },
    {
      name: t("order.orderList.orderTabs.cancelledTab"),
      state: "-1",
    },
  ];

  // 接收父级传入的参数
  const { updateNumber, initRecommendMainSkus } = useOutletContext<ProfileListContext>();

  const loadOrderList = () => {
    const orderInfo = sessionStorage.getItem("orderInfo") || "{}";
    // session 用完后清除，防止其他页面进入后显示不正确
    sessionStorage.removeItem("orderInfo");
    const orderInfoObj = JSON.parse(orderInfo);
    orderInfoObj.pageNum && orderStore.setPageNum(orderInfoObj.pageNum);
    orderInfoObj.orderType && orderStore.setOrderType(orderInfoObj.orderType);
    orderStore.getOrderList({
      page: orderInfoObj.pageNum ? String(orderInfoObj.pageNum) : orderStore.pageNum ? String(orderStore.pageNum) : "1",
      state: orderInfoObj.orderType ? orderInfoObj.orderType : orderStore.orderType || "4096",
    });
  };

  useEffect(() => {
    const tabName = orderTabList.find((item) => item?.state === orderStore.orderType)?.name;
    sendPv.OrderCenter_List({
      from_page: "",
      tab_name: tabName || "All",
    });
    loadOrderList();
  }, []);

  useEffect(() => {
    console.log(orderStore?.orderListInfo?.orderInfoDTOS, "9999");
    if (orderStore?.orderListInfo?.orderInfoDTOS?.length) {
      const allWareList =
        orderStore?.orderListInfo?.orderInfoDTOS?.map((item: { wareInfoList: WareInfoListVo[] }) => item?.wareInfoList?.map((ware) => ware?.wareId)) || [];
      const wareList = [].concat(...allWareList);
      // 使用 Set 去重
      const uniqueWareList = [...new Set(wareList)];
      // skuId最大10个
      const firstTenItems = uniqueWareList.slice(0, Math.min(uniqueWareList.length, 10));
      initRecommendMainSkus(firstTenItems.join(","));
    }
  }, [orderStore?.orderListInfo?.orderInfoDTOS]);

  // useEffect(() => {
  //   const orderInfo = sessionStorage.getItem("orderInfo") || "{}";
  //   const orderInfoObj = JSON.parse(orderInfo);
  //   setTimeout(() => {
  //     const orderList = orderStore?.orderListInfo?.orderInfoDTOS || [];
  //     const pageHeight = document.documentElement.scrollHeight;
  //     console.log(orderList.length, document.documentElement.scrollHeight);
  //     if (
  //       orderList.length &&
  //       !orderStore?.error &&
  //       orderInfoObj.scrollY > 436 &&
  //       orderInfoObj.scrollY <= pageHeight
  //     ) {
  //       console.log(orderInfoObj.scrollY, 23233);
  //       window.scrollTo(0, orderInfoObj.scrollY); // 页面跳转时滚动到顶部
  //     } else {
  //       console.log(55645666);
  //       window.scrollTo(0, 0); // 页面跳转时滚动到顶部
  //     }
  //   }, 600);
  // }, []);

  useEffect(() => {
    window.scrollTo(0, 0); // 页面跳转时滚动到顶部
  }, []);

  return (
    <div className={styles.order_content}>
      <Helmet>
        <title>My Orders | Joybuy</title>
        <meta
          name="description"
          content="Joybuy offers the best online shopping experience with fast shipping and delivery guarantee on all orders. Shop now for unbeatable deals on top-quality products."
        />
      </Helmet>
      <div className={styles.order_title_wrap}>
        <div className={styles.order_title}>My orders</div>
      </div>
      <OrderTabs updateNumber={updateNumber} />
    </div>
  );
});

export default OrderList;
